module.exports = __webpack_public_path__ + "21d4dec88418e873614518eee186a3bc.png";